import React, { useState, useRef } from 'react';
import './EmailSignatures.css';

const EmailSignatures = () => {
    const [name, setName] = useState('');
    const [position, setPosition] = useState('');
    const [company, setCompany] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [logo, setLogo] = useState(null);
    const previewRef = useRef(null);

    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setLogo(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleGenerateSignature = () => {
        const canvas = document.createElement('canvas');
        // Standard resolution scale optimized for crisp mobile retina emails
        canvas.width = 500;
        canvas.height = 200;
        const ctx = canvas.getContext('2d');

        // Clean white document background canvas base
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        const drawCanvasContent = () => {
            // 1. Setup typography matching our premium brand styling
            ctx.fillStyle = '#0f172a'; // Deep slate carbon text color
            ctx.font = '700 24px Montserrat, sans-serif';
            ctx.fillText(name || 'Your Name', 24, 44);

            ctx.fillStyle = '#2563eb'; // Brand Primary Blue color link highlight
            ctx.font = '600 16px Montserrat, sans-serif';
            ctx.fillText(`${position || 'Position'} | ${company || 'Company'}`, 24, 76);

            // Divider rule pipeline vector accent lines
            ctx.strokeStyle = '#cbd5e1';
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(24, 96);
            ctx.lineTo(canvas.width - 240, 96);
            ctx.stroke();

            // 2. Details Metadata segment fields block placement
            ctx.fillStyle = '#64748b'; // Soft premium slate grey text
            ctx.font = '500 15px Montserrat, sans-serif';
            ctx.fillText(`✉  ${email || 'name@company.com'}`, 24, 132);
            ctx.fillText(`📞  ${phoneNumber || '+44 7700 900077'}`, 24, 164);

            // 3. Complete and pipe out to user memory storage cache pipeline
            copyToClipboard(canvas);
        };

        // Draw structural asset image payloads asynchronously 
        if (logo) {
            const img = new Image();
            img.src = logo;
            img.onload = () => {
                // Pin client identity graphics inside the right-hand container quadrant cleanly
                ctx.drawImage(img, canvas.width - 114, 24, 90, 90);
                drawCanvasContent();
            };
        } else {
            drawCanvasContent();
        }
    };

    const copyToClipboard = (canvas) => {
        canvas.toDataURL('image/png');
        canvas.toBlob((blob) => {
            if (!blob) return;
            const item = new ClipboardItem({ 'image/png': blob });
            navigator.clipboard.write([item]).then(() => {
                alert('Success! Crisp high-definition email signature copied directly to clipboard.');
            }).catch(err => {
                console.error('Browser clipboard interception error:', err);
            });
        }, 'image/png');
    };

    return (
        <div className="email-signature-container">
            <h1 className="email-signature-title">Email Signatures</h1>

            <div className="main-content-emailsignatures">
                {/* Left Area Layout Block View Frame: Interactive Preview Display */}
                <div className="signature-preview-container">
                    <div className="signature-preview" ref={previewRef}>
                        <div className="signature-layout-inner">
                            <div className="signature-text-stack">
                                <h2 className="sig-name">{name || 'Your Name'}</h2>
                                <p className="sig-meta-headline">{position || 'Position'} | {company || 'Company'}</p>
                                <div className="sig-divider"></div>
                                <div className="sig-contact-block">
                                    <p className="sig-field"><span>✉</span> {email || 'name@company.com'}</p>
                                    <p className="sig-field"><span>📞</span> {phoneNumber || '+44 7700 900077'}</p>
                                </div>
                            </div>
                            {logo && (
                                <div className="sig-logo-holder">
                                    <img src={logo} alt="Brand Identifier Graphic Logo" />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="button-section">
                        <button className="generate-cta-btn" onClick={handleGenerateSignature}>
                            Generate & Copy to Clipboard
                        </button>
                    </div>
                </div>

                {/* Right Area Layout Block View Frame: Input Form Dashboard Controls wrapper panel */}
                <div className="input-section">
                    <label>
                        Full Name
                        <input type="text" placeholder="John Doe" value={name} onChange={(e) => setName(e.target.value)} />
                    </label>
                    <label>
                        Job Title
                        <input type="text" placeholder="Senior Product Designer" value={position} onChange={(e) => setPosition(e.target.value)} />
                    </label>
                    <label>
                        Company Name
                        <input type="text" placeholder="Digicard Ltd" value={company} onChange={(e) => setCompany(e.target.value)} />
                    </label>
                    <label>
                        Corporate Email Address
                        <input type="email" placeholder="john@digicard.com" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </label>
                    <label>
                        Direct Phone Number
                        <input type="tel" placeholder="+44 7700 900077" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
                    </label>

                    {/* Integrated custom identity design drag drop interface module built directly into custom form block layout */}
                    <div className="embedded-upload-zone">
                        <span className="upload-zone-label">Brand Assets Logo</span>
                        <input type="file" id="logoUpload" accept="image/*" onChange={handleLogoUpload} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmailSignatures;